'use es6';

import SystemPageSubTypes from '../constants/SystemPageSubTypes';
export default {
  ALL: 'all-products',
  NONE: 'NONE',
  EMAIL_TEMPLATES: 'EMAIL',
  LANDING_PAGES: 'LANDING_PAGE',
  SITE_PAGES: 'SITE_PAGE',
  BLOG_TEMPLATES: 'BLOG',
  PACKS: 'COS_TEMPLATE_PACK',
  UNSUBSCRIBE_SIMPLE: SystemPageSubTypes.UNSUBSCRIBE_SIMPLE,
  ERROR_PAGE: SystemPageSubTypes.ERROR_PAGE,
  PASSWORD_PAGE: SystemPageSubTypes.PASSWORD_PAGE,
  SUBSCRIPTION_PREFERENCES: SystemPageSubTypes.SUBSCRIPTION_PREFERENCES,
  UNSUBSCRIBE_CONFIRMATION: SystemPageSubTypes.UNSUBSCRIBE_CONFIRMATION,
  CONTENT_SEARCH_RESULTS: SystemPageSubTypes.CONTENT_SEARCH_RESULTS,
  CUSTOM_MODULE: 'CUSTOM_MODULE',
  CMS_THEME: 'CMS_THEME'
};